import Header from '../../components/feature/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import WhyChooseUs from './components/WhyChooseUs';
import PriceHighlights from './components/PriceHighlights';
import Promos from './components/Promos';
import Gallery from './components/Gallery';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <Services />
      <WhyChooseUs />
      <PriceHighlights />
      <Promos />
      <Gallery />
      <Testimonials />
      <FAQ />
      <About />
      <Contact />
      <Footer />
    </div>
  );
}
